/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import history from 'utils/history';
import appReducer from 'ui/containers/App/reducer';
import { defineApiActionTypes } from 'utils/action-helper';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */

const LOGOUT_USER = defineApiActionTypes(`ui/containers/ProjectDetailsPage/LOGOUT_USER`);

export const createReducer = (injectedReducers = {}) => {
  const globalReducer = combineReducers({
    global: appReducer,
    router: connectRouter(history),
    ...injectedReducers,
  });

  const rootReducer = (state, action) => {
    if (action.type === LOGOUT_USER.SUCCESS) return globalReducer(undefined, action);
    return globalReducer(state, action);
  };

  return rootReducer;
};
